module.exports = __webpack_public_path__ + "static/media/close-button.e7a3cf87.svg";